import type { IconNode } from '../types';

/**
 * @name watermelon
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMjEuNyAxNy43YTEuMDggMS4wOCAwIDAgMS0uMDggMS41N0ExMiAxMiAwIDAgMSA0LjczIDIuMzhhMS4xIDEuMSAwIDAgMSAxLjYxLS4wNFoiIC8+CiAgPHBhdGggZD0iTTE5LjcgMTUuN0E4IDggMCAwIDEgOC4zNSA0LjM0IiAvPgogIDxwYXRoIGQ9Ik0xMCAxMWguMDEiIC8+CiAgPHBhdGggZD0iTTEzIDE0aC4wMSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/watermelon
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const watermelon: IconNode = [
  [
    'path',
    {
      d: 'M21.7 17.7a1.08 1.08 0 0 1-.08 1.57A12 12 0 0 1 4.73 2.38a1.1 1.1 0 0 1 1.61-.04Z',
      key: '1h68we',
    },
  ],
  ['path', { d: 'M19.7 15.7A8 8 0 0 1 8.35 4.34', key: '79br1i' }],
  ['path', { d: 'M10 11h.01', key: 'd2at3l' }],
  ['path', { d: 'M13 14h.01', key: '66kovr' }],
];

export default watermelon;
